<template>
    <header class="stl-page-header">
        <div class="stl-page-header-left">
            <h1 class="stl-page-title">다세대 요금 정산</h1>
            <p v-if="site" class="stl-page-context">
                {{ site.siteName }}
                <span class="stl-header-badge">{{ householdCount }}세대</span>
                <span class="stl-header-badge">검침 {{ site.readingDay }}일</span>
                <span :class="formatStatusClass(matrixStatus)">{{ formatStatusLabel(matrixStatus) }}</span>
            </p>
        </div>
        <div class="stl-page-header-right">
            <div class="stl-toolbar-pill">
                <SettlementMonthPicker :value="ym" @input="$emit('update:ym', $event)" />
                <span class="stl-vr"></span>
                <div class="stl-seg">
                    <button
                        v-if="showAllEnergy"
                        type="button"
                        :class="{ on: energySource === 'ALL' }"
                        @click="$emit('update:energySource', 'ALL')"
                    >
                        전체
                    </button>
                    <button
                        type="button"
                        :class="{ on: energySource === 'Elec' }"
                        :disabled="site && site.elecEnabled !== 'Y'"
                        @click="$emit('update:energySource', 'Elec')"
                    >
                        전기
                    </button>
                    <button
                        type="button"
                        :class="{ on: energySource === 'Gas' }"
                        :disabled="site && site.gasEnabled !== 'Y'"
                        @click="$emit('update:energySource', 'Gas')"
                    >
                        가스
                    </button>
                    <button
                        type="button"
                        :class="{ on: energySource === 'Water' }"
                        :disabled="site && site.waterEnabled !== 'Y'"
                        @click="$emit('update:energySource', 'Water')"
                    >
                        수도
                    </button>
                </div>
                <span class="stl-vr"></span>
                <div class="stl-seg">
                    <button type="button" :class="{ on: mainTab === 'dashboard' }" @click="$emit('update:mainTab', 'dashboard')">대시보드</button>
                    <button type="button" :class="{ on: mainTab === 'ledger' }" @click="$emit('update:mainTab', 'ledger')">정산대장</button>
                </div>
                <span class="stl-vr"></span>
                <button type="button" class="stl-btn stl-btn-primary stl-btn-sm" @click="$emit('open-run')">
                    <i class="fa fa-calculator"></i> 정산 실행
                </button>
                <button type="button" class="stl-btn stl-btn-sm" @click="$emit('open-site')">단지정보</button>
                <button type="button" class="stl-btn stl-btn-ghost stl-btn-sm" :disabled="loading" @click="$emit('refresh')">
                    <i class="fa fa-refresh"></i>
                </button>
            </div>
        </div>
    </header>
</template>

<script>
import SettlementMonthPicker from "./SettlementMonthPicker.vue";
import { statusLabel, statusClass } from "../utils/settlementFormat.js";

export default {
    name: "SettlementHeader",
    components: { SettlementMonthPicker },
    props: {
        site: { type: Object, default: null },
        ym: { type: String, required: true },
        energySource: { type: String, default: "Elec" },
        loading: { type: Boolean, default: false },
        matrixStatus: { type: String, default: null },
        householdCount: { type: Number, default: 0 },
        mainTab: { type: String, default: "dashboard" },
    },
    computed: {
        showAllEnergy() {
            if (!this.site) return false;
            let n = 0;
            if (this.site.elecEnabled === "Y") n += 1;
            if (this.site.gasEnabled === "Y") n += 1;
            if (this.site.waterEnabled === "Y") n += 1;
            return n > 1;
        },
    },
    methods: {
        formatStatusLabel(status) {
            return status ? statusLabel(status) : "미정산";
        },
        formatStatusClass(status) {
            return status ? statusClass(status) : "stl-badge stl-badge-none";
        },
    },
};
</script>
